import React, { useEffect, useState } from 'react';

import AttachFileContainer from 'app/containers/AttachFileContainer/AttachFileContainer';
import AzureMPContainer from 'app/containers/AzureMSContainer/AzureMSContainer';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import CourseCategoryContainer from 'app/containers/CourseCategoryContainer';
import SpecialtyContainer from 'app/containers/SpecialtyContainer';
import CourseTestAvailableContainer from 'app/containers/CourseTestAvailableContainer';
import CourseWorkCycleAvailableContainer from 'app/containers/CourseWorkCycleAvailableContainer';
import CourseClientProcedureAvailableContainer from 'app/containers/CourseClientProcedureAvailableContainer';
import CourseHomologousProcedureAvailableContainer from 'app/containers/CourseHomologousProcedureAvailableContainer';
import SubdirectionsContainer from 'app/containers/SubdirectionsContainer';
import TextEvents from 'app/components/TextEvents';
import TextInput from 'app/components/TextInput';
import { useStyles } from './CreateProcedureStyles';
import { Modal, Select, Input, Transfer, Button, Icon, Tabs, Checkbox, Alert } from 'antd';
import ApiService from 'app/services/ApiService'
import { useDispatch, useSelector } from 'react-redux';
import { fetchCourse, courseClear, courseFilterClear, fetchCourseFilter, fetchTestAvailableCourseById, fetchCategoryAvailableCourseApproveById, fetchCategoryAvailableCourseById } from 'app/actions/CourseActions';
import { clearCourseMultimedia } from 'app/actions/CourseMultimediaActions';
import { attachmentClear } from "app/actions/AttachmentActions";
import * as TrainingActions from "app/actions/TrainingActions";
import { getSystemSpecialty } from "app/actions/SystemActions";

const { TabPane } = Tabs;
const { TextArea } = Input;
const { confirm } = Modal;

export default function CreateProcedure(props) {

    const {
        Permissions
        , Roles
    } = useSelector(state => state.Auth.item.User);

    const classes = useStyles();
    const dispatch = useDispatch();
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [id, setId] = useState(0);
    const [isCourse, setCourseStatus] = useState(true);
    const [subdir, setSubdir] = useState([]);
    const [courseFolio, setCourseFolio] = useState('');
    const [courseName, setCourseName] = useState('');
    const [courseCode, setCourseCode] = useState('');
    const [description, setDesc] = useState('');
    const [courseSupportFileDate, setCourseSupportFileDate] = useState(null);
    const [loadDocument, setLoadDocument] = useState(false);
    const [version, setVersion] = useState(0);
    const [isDocument, setDocumentStatus] = useState(false);
    const [isMultimedia, setIsMultimediaStatus] = useState(false);
    const [isCategory, setCategoryStatus] = useState(false);
    const [isWorkCycle, setWorkCycleStatus] = useState(false);
    const [isTest, setTestStatus] = useState(false);
    const [isClientProcedure, setClientProcedureStatus] = useState(false);
    const [isSaved, setSaved] = useState(false);

    const [evaluation, setEvaluation] = useState([]);
    const [workCycle, setWorkCycle] = useState([]);
    const [targetCategory, settargetCategory] = useState([]);
    const [targetCategoryApprove, settargetCategoryApprove] = useState([]);
    const [targetClientProcedure, settargetClientProcedure] = useState([]);
    const [sourceClientProcedure, setsourceClientProcedure] = useState([]);
    const [targetHomologousProcedure, settargetHomologousProcedure] = useState([]);
    const [sourceHomologousProcedure, setsourceHomologousProcedure] = useState([]);
    const [video, setVideo] = useState();

    const [course, setCourse] = useState([]);
    const [blockConfig, setBlockConfig] = useState(false);
    const [migrate, setMigrate] = useState();
    const [localAttachment, setAttachment] = useState();

    const [idTraining, setIdTraining] = useState(undefined);
    const [idSystemSpecialty, setIdSystemSpecialty] = useState(undefined);
    const [subdirCategory, setSubdirCategory] = useState(undefined);
    const [subdirCategoryApprove, setSubdirCategoryApprove] = useState(undefined);
    const [notApply, setNotApply] = useState(false);

    const [applyAll, setApplyAll] = useState(false);
    const [applyGCM, setApplyGCM] = useState(false);
    const [notApplyColab, setNotApplyColab] = useState(false);

    const [onSiteTest, setOnSiteTest] = useState(false);
    const [notCotplayHub, setNotCotplayHub] = useState(false);

    const {
        idSubdirection,
        employeeId,
        subdirectionName
    } = useSelector(state => state.Auth.employeeById)

    const {
        trainingSelect,
        isLoadTrainingSelect
    } = useSelector(state => state.TrainingReducer)

    const {
        systemSpecialty,
        isLoadSystemSpecialty
    } = useSelector(state => state.SystemReducer)

    const {
        allCourseCategoryAvailableApprove,
        allCourseCategoryAvailable,
        isLoadingApprove
    } = useSelector(state => state.Course)

    const dataSourceCategory = allCourseCategoryAvailable.map((item) => {
        return {
            'key': item.idCategory,
            'idCategory': item.idCategory,
            'categoryName': item.categoryName,
            'idSubdirection': item.idSubdirection
        }
    });

    const dataSourceCategoryApprove = allCourseCategoryAvailableApprove.map((item) => {
        return {
            'key': item.idCategory,
            'idCategory': item.idCategory,
            'categoryName': item.categoryName,
            'idSubdirection': item.idSubdirection
        }
    });

    const optionTraining = trainingSelect.map((item) =>
        <Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>
    );

    const optionSystem = systemSpecialty.filter(x => x.isSystem).map((item) =>
        <Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>
    );

    const optionSpecialty = systemSpecialty.filter(x => !x.isSystem && x.idTraining === idTraining).map((item) =>
        <Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>
    );

    const findSubdir = (params, item) => {
        let temp = [];
        params.subdirs.forEach(v => {
            if (String(v.idSubdirection) === item.key) temp.push(v);

        });
        setSubdir(temp);
    }

    const validateAdminGeneralRol = () => {
        let findRol = Roles.find(rol => rol.NameRole.includes("Administrador General"))
        return findRol ? true : false;
    }

    const permisosArray = () => {
        let permissions = Permissions.filter(x => x.NameController === 'CourseScreen' && x.Description.includes("Modulo de")).map(item => {
            return item.NameResource;
        })
        let response = ["Eliminar"];
        permissions.forEach(row => {
            switch (row) {
                case "ModuleCourseDocument":
                    response.splice(0, 0, "ModuleCourseDocument");
                    break;
                case 'ModuleCourseCategory':
                    response.splice(1, 0, "ModuleCourseCategory");
                    break;
                case "ModuleCourseMultimedia":
                    response.splice(2, 0, "ModuleCourseMultimedia");
                    break;
                case "ModuleCourseEvaluation":
                    response.splice(3, 0, "ModuleCourseEvaluation");
                    break;
                case "ModuleCourseDutyCycle":
                    response.splice(4, 0, "ModuleCourseDutyCycle");
                    break;
                case "ModuleCourseClientProcedure":
                    response.splice(5, 0, "ModuleCourseClientProcedure");
                    break;
            }

        })
        return response.filter(x => x != "Eliminar")
    }

    const validateViewAdminGeneral = (item) => {

        let permissions = Permissions.filter(x => x.NameController === 'CourseScreen' && x.Description.includes("Modulo de")).map(item => {
            return item.NameResource;
        })

        switch (item) {
            case "Documento":
                return permissions.find(item => item === 'ModuleCourseDocument') ? true : false;
            case "Puestos":
                return permissions.find(item => item === 'ModuleCourseCategory') ? true : false;
            case "Multimedia":
                return permissions.find(item => item === 'ModuleCourseMultimedia') ? true : false;
            case "Evaluación":
                return permissions.find(item => item === 'ModuleCourseEvaluation') ? true : false;
            case "Ciclo de trabajo":
                return permissions.find(item => item === 'ModuleCourseDutyCycle') ? true : false;
            case "Clas. Cliente y Proc. homólogo":
                return permissions.find(item => item === 'ModuleCourseClientProcedure') ? true : false;
        }


        return false
    }

    const validateViewOptionsAdminGeneral = (item) => {
        let permissions = Permissions.filter(x => x.NameController === 'CourseScreen' && x.Description.includes("CheckBox para")).map(item => {
            return item.NameResource;
        })

        switch (item) {
            case "applyAll":
                return permissions.find(item => item === 'cbxCourseAllSubdirection') ? true : false;
            case "applyGCM":
                return permissions.find(item => item === 'cbxCourseAllGCM') ? true : false;
            case "notApplyColab":
                return permissions.find(item => item === 'cbxCourseNoApply') ? true : false;
            case "notApply":
                return permissions.find(item => item === 'cbxCourseNoApplyEvaluation') ? true : false;

        }

        return false
    }

    const applyAllCB = () => {
        return (
            <Grid xs={6} item>
                <Checkbox checked={applyAll} onChange={(e) => setApplyAll_(e.target.checked)} disabled={notApplyColab || applyGCM}>Aplica a todos los empleados de la dirección</Checkbox>
            </Grid>
        )
    }
    const applyGCMCB = () => {
        return (
            <Grid xs={6} item>
                <Checkbox checked={applyGCM} onChange={(e) => setApplyGCM_(e.target.checked)} disabled={notApplyColab || applyAll}>Aplica a todos los empleados del GCM</Checkbox>

            </Grid>
        )
    }
    const notApplyCB = () => {
        return (
            <Grid xs={6} item>
                <Checkbox checked={notApplyColab} onChange={(e) => setDontApply(e.target.checked)} disabled={applyAll || applyGCM}>No aplica</Checkbox>
            </Grid>
        )
    }
    const notApplyEvaCB = () => {
        return (
            <Checkbox checked={notApply} onChange={(e) => doesNotApply(e.target.checked)}>No aplica</Checkbox>
        )
    }


    const documentoOptionView = () => {
        return (
            <ListItem button className={classes.nested} selected={selectedIndex === 1} onClick={attachmentClick} disabled={blockConfig} key={1}>
                <ListItemIcon className={classes.icon}>
                    <Icon type="file-text" />
                </ListItemIcon>
                <ListItemText secondary={'Documento'} />
            </ListItem>
        )
    }

    const puestosOptionView = () => {
        return (
            <ListItem button className={classes.nested} selected={selectedIndex === 2} onClick={CategoryClick} disabled={blockConfig} key={2}>
                <ListItemIcon className={classes.icon}>
                    <Icon type="gold" />
                </ListItemIcon>
                <ListItemText secondary={'Puestos'} />
            </ListItem>
        )
    }

    const multimediaOptionView = () => {
        return (
            <ListItem button className={classes.nested} selected={selectedIndex === 3} onClick={multimediaClick} disabled={blockConfig} key={3}>
                <ListItemIcon className={classes.icon}>
                    <Icon type="play-square" />
                </ListItemIcon>
                <ListItemText secondary={'Multimedia'} />

            </ListItem>
        )
    }

    const evaluationOptionView = () => {
        return (
            <ListItem button className={classes.nested} selected={selectedIndex === 4} onClick={EvaluationClick} disabled={blockConfig} key={4}>
                <ListItemIcon className={classes.icon}>
                    <Icon type="profile" />
                </ListItemIcon>
                <ListItemText secondary={'Evaluación'} />
            </ListItem>
        )
    }

    const workCycleOptionView = () => {
        return (
            <ListItem button className={classes.nested} selected={selectedIndex === 5} onClick={WCycleClick} disabled={blockConfig} key={5}>
                <ListItemIcon className={classes.icon}>
                    <Icon type="tool" />
                </ListItemIcon>
                <ListItemText secondary={'Ciclo de trabajo'} />

            </ListItem>
        )
    }

    const procedureOptionView = () => {
        return (
            <ListItem button className={classes.nested} selected={selectedIndex === 6} onClick={ClientProcedureClick} disabled={blockConfig} key={6}>
                <ListItemIcon className={classes.icon}>
                    <Icon type="snippets" />
                </ListItemIcon>
                <ListItemText secondary={'Clas. Cliente y Proc. homólogo'} />
            </ListItem>
        )
    }

    const setApplyAll_ = (item) => {
        setApplyAll(item)
        findCategoryBySubdirection(subdir[0].idSubdirection)
        settargetCategory([]);
    }

    const setApplyGCM_ = (item) => {
        setApplyGCM(item);
    }

    const setDontApply = (item) => {
        setNotApplyColab(item)
        findCategoryBySubdirection(subdir[0].idSubdirection)
        settargetCategory([]);
    }

    const findEvaluation = (params, item) => {
        let temp = [];
        params.courseTestAvailable.forEach(v => {
            if (String(v.idTest) === item) temp.push(v);
        });
        setEvaluation(temp);
    }

    const findWorkCycle = (params, item) => {
        let temp = [];
        params.courseWorkCycleAvailable.forEach(v => {
            if (String(v.idTest) === item) temp.push(v);
        });
        setWorkCycle(temp);
    }

    const attachmentClick = () => {
        setSelectedIndex(1);
        setCourseStatus(false);
        setDocumentStatus(true);
        setIsMultimediaStatus(false);
        setCategoryStatus(false);
        setTestStatus(false);
        setWorkCycleStatus(false);
        setClientProcedureStatus(false);

    }


    const CategoryClick = () => {
        setSelectedIndex(2);
        setCourseStatus(false);
        setDocumentStatus(false);
        setIsMultimediaStatus(false);
        setCategoryStatus(true);
        setTestStatus(false);
        setWorkCycleStatus(false);
        setClientProcedureStatus(false);

    }

    const multimediaClick = () => {
        setSelectedIndex(3);
        setCourseStatus(false);
        setDocumentStatus(false);
        setIsMultimediaStatus(true);
        setTestStatus(false);
        setWorkCycleStatus(false);
        setClientProcedureStatus(false);

    }

    const EvaluationClick = () => {
        setSelectedIndex(4);
        setCourseStatus(false);
        setDocumentStatus(false);
        setIsMultimediaStatus(false);
        setCategoryStatus(false);
        setTestStatus(true);
        setWorkCycleStatus(false);
        setClientProcedureStatus(false);

    }

    const WCycleClick = () => {
        setSelectedIndex(5);
        setCourseStatus(false);
        setDocumentStatus(false);
        setIsMultimediaStatus(false);
        setCategoryStatus(false);
        setTestStatus(false);
        setWorkCycleStatus(true);
        setClientProcedureStatus(false);

    }

    const ClientProcedureClick = () => {
        setSelectedIndex(6);
        setCourseStatus(false);
        setDocumentStatus(false);
        setIsMultimediaStatus(false);
        setCategoryStatus(false);
        setTestStatus(false);
        setWorkCycleStatus(false);
        setClientProcedureStatus(true);
    }


    const handleClick = () => {
        setSelectedIndex(0);
        setCourseStatus(true);
        setDocumentStatus(false);
        setIsMultimediaStatus(false);
        setCategoryStatus(false);
        setTestStatus(false);
        setWorkCycleStatus(false);
        setClientProcedureStatus(false);

    }


    const filterOptionCategory = (inputValue, option) => {
        return option.categoryName.toUpperCase().indexOf(inputValue.toUpperCase()) > -1
    };

    const filterOptionClientProcedure = (inputValue, option) => {
        return option.procedureName.toUpperCase().indexOf(inputValue.toUpperCase()) > -1
    };

    const filterOptionHomologousProcedure = (inputValue, option) => {
        return option.procedureName.toUpperCase().indexOf(inputValue.toUpperCase()) > -1
    };

    const showConfirm = (type) => {

        confirm({
            title: '¿Guardar Procedimiento?',
            content: courseName,
            okText: 'Guardar',
            cancelText: 'Cancelar',
            onOk() {
                return ApiService.setCourses(
                    {
                        SubdirectionId: subdir[0].idSubdirection,
                        idTraining: idTraining,
                        isSystem: idTraining === 'TK0000000002',
                        idSystemSpecialty: idSystemSpecialty,
                        courseCode: courseCode,
                        courseName: courseName,
                        courseDescription: description,
                        courseVersion: version.toString(),
                        listCategory: [],
                        listCategoryApprove: [],
                        listClientProcedure: [],
                        listHomologousProcedure: [],
                        listTest: [],
                        listTestWorkCycle: [],
                        courseSupportFileDate: null,
                        IsAdminGeneral: validateAdminGeneralRol(),
                        PermisosPantalla: validateAdminGeneralRol() ? permisosArray() : []
                    }, 'POST')
                    .then(
                        response => {
                            setCourse(response);

                            setId(response.idCourse);
                            setCourseFolio(response.courseFolio);
                            dispatch(courseFilterClear());
                            dispatch(fetchCourseFilter({
                                employeeId: employeeId,
                                subdirectionId: idSubdirection
                            }));
                            dispatch(attachmentClear());
                            confirm({
                                title: 'Procedimiento guardado correctamente.',
                                content: '¿Desea continuar la configuración?',
                                okText: 'Aceptar',
                                cancelText: 'Más tarde',
                                onOk() {

                                    dispatch(courseClear());
                                    dispatch(fetchCourse(
                                        {
                                            ...props.formData,
                                            employeeId: employeeId,
                                            subdirectionId: idSubdirection.Alert,
                                            IsAdminGeneral: validateAdminGeneralRol(),
                                            PermisosPantalla: validateAdminGeneralRol() ? permisosArray() : []
                                        }
                                    ));
                                    dispatch(courseFilterClear());
                                    dispatch(fetchCourseFilter({
                                        employeeId: employeeId,
                                        subdirectionId: idSubdirection
                                    }));

                                    setBlockConfig(false);
                                    setCourseStatus(false);
                                    if (validateAdminGeneralRol()) {
                                        var arrModules = permisosArray();
                                        if (arrModules.length > 0) {
                                            switch (arrModules[0]) {
                                                case "ModuleCourseDocument":
                                                    attachmentClick()
                                                    break;
                                                case "ModuleCourseCategory":
                                                    CategoryClick()
                                                    break;
                                                case "ModuleCourseMultimedia":
                                                    multimediaClick()
                                                    break;
                                                case "ModuleCourseEvaluation":
                                                    EvaluationClick()
                                                    break;
                                                case "ModuleCourseDutyCycle":
                                                    WCycleClick();
                                                    break;
                                                case "ModuleCourseClientProcedure":
                                                    ClientProcedureClick();
                                                    break;

                                            }
                                        }
                                    } else {
                                        if (idTraining === "TK0000000002") {
                                            setSelectedIndex(2);
                                            setCategoryStatus(true);
                                        }
                                        else {
                                            setSelectedIndex(1);
                                            setDocumentStatus(true);

                                        }
                                    }

                                    setSaved(true);
                                    dispatch(fetchCategoryAvailableCourseById({
                                        idCourse: response.idCourse,
                                        isApprover: false,
                                        idSubdirection: idSubdirection
                                    }));
                                    dispatch(fetchCategoryAvailableCourseApproveById({
                                        idCourse: response.idCourse,
                                        isApprover: true,
                                        idSubdirection: idSubdirection
                                    }))
                                },
                                onCancel() {
                                    dispatch(courseClear());
                                    dispatch(fetchCourse(
                                        {
                                            ...props.formData,
                                            employeeId: employeeId,
                                            subdirectionId: idSubdirection,
                                            IsAdminGeneral: validateAdminGeneralRol(),
                                            PermisosPantalla: validateAdminGeneralRol() ? permisosArray() : []
                                        }
                                    ));
                                    dispatch(courseFilterClear());
                                    dispatch(fetchCourseFilter({
                                        employeeId: employeeId,
                                        subdirectionId: idSubdirection
                                    }));
                                    props.setTab('1')
                                },
                            });
                        }, error => {
                            Modal.error({
                                title: 'Ops, error de conexión',
                                content: 'Se perdió la conexión de red, intente más tarde.',
                            });
                        }
                    )
            },
            onCancel() { },
        });
    }

    const showSecondaryConfirm = () => {
        confirm({
            title: '¿Guardar configuración de procedimiento?',
            //content: diffusion,
            okText: 'Guardar',
            cancelText: 'Cancelar',
            onOk() {
                const listCategory = targetCategory.map(x => ({ idCategory: x.idCategory, idSubdirection: x.idSubdirection }));
                let idsEval = evaluation.map(i => i.idTest);
                let idsWork = workCycle.map(i => i.idTest);
                let idsSub = subdir.map(i => i.idSubdirection);
                if (typeof migrate === "undefined") {
                    const data = {
                        idCourse: course.idCourse,
                        SubdirectionId: subdir[0].idSubdirection,
                        idTraining: idTraining,
                        isSystem: idTraining === 'TK0000000002',
                        idSystemSpecialty: idSystemSpecialty,
                        courseCode: course.courseCode,
                        courseName: course.courseName,
                        courseDescription: course.courseDescription,
                        courseVersion: course.courseVersion?.toString(),
                        listCategory: listCategory,
                        listCategoryApprove: idTraining === 'TK0000000001' ? targetCategoryApprove.map(x => ({ idCategory: x.idCategory, idSubdirection: x.idSubdirection })) : [],
                        listClientProcedure: targetClientProcedure,
                        listHomologousProcedure: targetHomologousProcedure,
                        listTest: notApply ? [] : idsEval,
                        notApply: notApply,
                        listTestWorkCycle: idTraining === 'TK0000000001' ? idsWork : [],
                        courseSupportFileDate: courseSupportFileDate,
                        ApplyAll: applyAll,
                        ApplyAllSubdirections: applyGCM,
                        NotApplyPosition: notApplyColab == null ? false : notApplyColab,
                        IsPresential: onSiteTest,
                        notShowCotplayHub: notCotplayHub == null ? false : notCotplayHub,
                        IsAdminGeneral: validateAdminGeneralRol(),
                        PermisosPantalla: validateAdminGeneralRol() ? permisosArray() : []
                    };

                    return ApiService.setCourses(data, 'PUT')
                        .then(
                            response => {
                                dispatch(courseClear());
                                dispatch(fetchCourse(
                                    {
                                        ...props.formData,
                                        employeeId: employeeId,
                                        subdirectionId: idSubdirection,
                                        IsAdminGeneral: validateAdminGeneralRol(),
                                        PermisosPantalla: validateAdminGeneralRol() ? permisosArray() : []
                                    }
                                ));
                                dispatch(clearCourseMultimedia());
                                dispatch(attachmentClear());
                                dispatch(courseFilterClear());
                                dispatch(fetchCourseFilter({
                                    employeeId: employeeId,
                                    subdirectionId: idSubdirection
                                }));
                                Modal.success({
                                    title: `Procedimiento guardado correctamente.`,
                                    content: response.testTitle,
                                }, props.setTab('1'));
                            }, error => {
                                Modal.error({
                                    title: 'Ops, error de conexión',
                                    content: 'Se perdió la conexión de red, intente más tarde.',
                                });
                            }
                        )
                }
                else
                    return ApiService.setAttachment(migrate).then(
                        () => {
                            ApiService.setCourses({
                                idCourse: course.idCourse,
                                SubdirectionId: subdir[0].idSubdirection,
                                idTraining: idTraining,
                                isSystem: idTraining === 'TK0000000002',
                                idSystemSpecialty: idSystemSpecialty,
                                courseCode: course.courseCode,
                                courseName: course.courseName,
                                courseDescription: course.courseDescription,
                                courseVersion: course.courseVersion?.toString(),
                                listCategory: listCategory,
                                listCategoryApprove: idTraining === 'TK0000000001' ? targetCategoryApprove.map(x => ({ idCategory: x.idCategory, idSubdirection: x.idSubdirection })) : [],
                                listClientProcedure: targetClientProcedure,
                                listHomologousProcedure: targetHomologousProcedure,
                                listTest: notApply ? [] : idsEval,
                                notApply: notApply,
                                ApplyAll: applyAll,
                                ApplyAllSubdirections: applyGCM,
                                NotApplyPosition: notApplyColab == null ? false : notApplyColab,
                                listTestWorkCycle: idTraining === 'TK0000000001' ? idsWork : [],
                                courseSupportFileDate: courseSupportFileDate,
                                IsPresential: onSiteTest,
                                notShowCotplayHub: notCotplayHub == null ? false : notCotplayHub,
                                IsAdminGeneral: validateAdminGeneralRol(),
                                PermisosPantalla: validateAdminGeneralRol() ? permisosArray() : []
                            }, 'PUT')
                                .then(
                                    response => {
                                        dispatch(courseClear());
                                        dispatch(fetchCourse(
                                            {
                                                ...props.formData,
                                                employeeId: employeeId,
                                                subdirectionId: idSubdirection,
                                                IsAdminGeneral: validateAdminGeneralRol(),
                                                PermisosPantalla: validateAdminGeneralRol() ? permisosArray() : []
                                            }
                                        ));
                                        dispatch(clearCourseMultimedia());
                                        dispatch(attachmentClear());
                                        dispatch(courseFilterClear());
                                        dispatch(fetchCourseFilter({
                                            employeeId: employeeId,
                                            subdirectionId: idSubdirection
                                        }));
                                        Modal.success({
                                            title: `Procedimiento guardado correctamente.`,
                                            content: response.testTitle,
                                        }, props.setTab('1'));
                                    }, error => {
                                        Modal.error({
                                            title: 'Ops, error de conexión',
                                            content: 'Se perdió la conexión de red, intente más tarde.',
                                        });
                                    }
                                )
                        }
                    );
            },
            onCancel() { },
        });
    }

    const doesNotApply = (check) => {
        setNotApply(check);
        setEvaluation([]);
    }

    const findCategoryBySubdirection = (item) => {
        setSubdirCategory(item);
        dispatch(fetchCategoryAvailableCourseById({
            // idCourse: !course.idCourse ? 425 : course.idCourse,
            idCourse: course.idCourse,
            isApprover: false,
            idSubdirection: item
        }, targetCategory.filter(x => String(x.idSubdirection) === String(subdirCategory)).map(i => i.idCategory)))
    }

    const findCategoryBySubdirectionApprove = (item) => {
        setSubdirCategoryApprove(item);
        dispatch(fetchCategoryAvailableCourseApproveById({
            idCourse: course.idCourse,
            isApprover: true,
            idSubdirection: item
        }, targetCategoryApprove.filter(x => String(x.idSubdirection) === String(subdirCategory)).map(i => i.idCategory)))
    }

    useEffect(() => {
        setSubdir([{
            idSubdirection: idSubdirection,
            subdirectionName: subdirectionName,
            deleted: false
        }])
        setSubdirCategory(idSubdirection);
        setSubdirCategoryApprove(idSubdirection);
        dispatch(TrainingActions.getTrainingSelect(employeeId));
        dispatch(getSystemSpecialty(idSubdirection));
    }, [dispatch])

    const filterOptionWorkCycle = (inputValue, option) => {
        return option.props.children.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
    };

    const filterOptionEV = (inputValue, option) => {
        return option.props.children.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
    };

    const documentStatusValidation = () => {
        const completed = 1;
        const incomplete = 0;
        const unload = -1;
        let documentStatus = loadDocument ? courseSupportFileDate !== null ? completed : incomplete : unload;

        let response = documentStatus == -1 && idTraining === 'TK0000000001' ? true : false;

        return response
    }

    const hasProblemsToSave = () => {
        /* Nota: Este codigo puedo ser simplificado, pero la verdad se revuleve luego uno xD */
        const completed = 1;
        const incomplete = 0;
        const unload = -1;

        /* Establece estatus del documento */
        let documentStatus = loadDocument ? courseSupportFileDate !== null ? completed : incomplete : unload;

        if (validateAdminGeneralRol()) {
            var arrModules = permisosArray();
            var response = false;

            for (var i = 0; i < arrModules.length; i++) {
                switch (arrModules[i]) {
                    case "ModuleCourseDocument":
                        if (documentStatus == -1)
                            response = true
                        break;
                    case "ModuleCourseCategory":
                        if (targetCategory.length === 0 && targetCategoryApprove.length === 0 && !notApplyColab && !applyGCM && !applyAll)
                            response = true
                        break;
                    case "ModuleCourseMultimedia":
                        if (onSiteTest === false && video === undefined)
                            response = true
                        break;
                    case "ModuleCourseEvaluation":
                        if (evaluation.length === 0 && (notApply === undefined || !notApply))
                            response = true
                        break;
                    case "ModuleCourseDutyCycle":
                        if (workCycle.length === 0)
                            response = true
                        break;
                    case "ModuleCourseClientProcedure":
                        if (targetClientProcedure.length === 0 && targetHomologousProcedure.length === 0)
                            response = true
                        break;
                }
            }

            return response;
        } else {

            if (documentStatus == -1 && idTraining === 'TK0000000001') {
                return true;
            }

            if (id === 0) {
                return true;
            }
            /* Se verifica que no halla problemas para guardar */
            let hasProblems = ((evaluation.length === 0 && (notApply === undefined || !notApply))
                && workCycle.length === 0 && targetCategory.length === 0 && targetCategoryApprove.length === 0
                && targetClientProcedure.length === 0 && targetHomologousProcedure.length === 0
                //&& (subdir[0].idSubdirection === 3 && idTraining === 'TK0000000001') ? targetClientProcedure.length === 0 && targetHomologousProcedure.length === 0 : false
                && (documentStatus !== completed)
                //&& (courseSupportFileDate === null || !loadDocument)
                || (documentStatus === incomplete)
                || idSystemSpecialty === undefined || idTraining === '' || courseCode === '' || courseName === '')

            /* Se regresa la respuesta xD */
            return hasProblems;
        }


    }

    const changeCategory = (e, d, m) => {
        if (d === 'right') {
            settargetCategory([...targetCategory, ...m.map(i => ({ idCategory: i, idSubdirection: subdirCategory }))]);
        }
        else {
            settargetCategory([...targetCategory.filter(x => !m.includes(x.idCategory))]);
        }
    }

    const changeCategoryApprove = (e, d, m) => {
        if (d === 'right') {
            settargetCategoryApprove([...targetCategoryApprove, ...m.map(i => ({ idCategory: i, idSubdirection: subdirCategoryApprove }))]);
        }
        else {
            settargetCategoryApprove([...targetCategoryApprove.filter(x => !m.includes(x.idCategory))]);
        }
    }

    return (
        <div>
            <Grid container direction="row">
                <Grid container direction="row">
                    <Grid xs={4} item>
                        <CardContent>
                            <div>
                                <List component="nav" disablePadding>
                                    <ListItem button className={classes.nested} selected={selectedIndex === 0} onClick={handleClick} key={0}>
                                        <ListItemIcon className={classes.icon}>
                                            <Icon type="folder" theme='twoTone' />
                                        </ListItemIcon>
                                        <ListItemText primary={courseCode !== '' ? `${courseCode}` : 'Procedimiento'} />
                                    </ListItem>
                                </List>
                                <Divider />
                                <List component="nav" disablePadding >
                                    {
                                        validateAdminGeneralRol() ? (validateViewAdminGeneral("Documento") ? documentoOptionView() : <div></div>) : (idTraining === undefined || idTraining !== 'TK0000000002') ?
                                            documentoOptionView() : <div></div>
                                    }

                                    {
                                        validateAdminGeneralRol() ? (validateViewAdminGeneral("Puestos") ? puestosOptionView() : <div></div>) : puestosOptionView()
                                    }
                                    {
                                        validateAdminGeneralRol() ? (validateViewAdminGeneral("Multimedia") ? multimediaOptionView() : <div></div>) : multimediaOptionView()
                                    }

                                    {
                                        validateAdminGeneralRol() ? (validateViewAdminGeneral("Evaluación") ? evaluationOptionView() : <div></div>) : evaluationOptionView()
                                    }
                                    {
                                        validateAdminGeneralRol() ? (validateViewAdminGeneral("Ciclo de trabajo") ? workCycleOptionView() : <div></div>) : (idTraining === undefined || idTraining === 'TK0000000001') ?
                                            workCycleOptionView() : <div></div>
                                    }
                                    {
                                        validateAdminGeneralRol() ? (validateViewAdminGeneral("Clas. Cliente y Proc. homólogo") ? procedureOptionView() : <div></div>) : (idTraining === 'TK0000000001' && subdir[0].idSubdirection === 3) ?
                                            procedureOptionView() : <div></div>
                                    }
                                </List>
                            </div>
                        </CardContent>
                    </Grid>
                    {
                        !isCourse ?
                            <Grid xs={8} item>
                                <Card className={classes.card}>
                                    <CardContent>
                                        <Grid container direction="row">
                                            <Grid item xs={6}>
                                                {
                                                    isMultimedia ?
                                                        <Checkbox checked={onSiteTest} onChange={(e) => { setOnSiteTest(e.target.checked) }}>Es presencial
                                                        </Checkbox>
                                                        : null
                                                }
                                            </Grid>
                                            <Grid item xs={6}>
                                                <div className={classes.buttonsContainer}>
                                                    {/* guardado por avance */}
                                                    <Button
                                                        variant='contained'
                                                        type='primary'
                                                        onClick={showSecondaryConfirm}
                                                        disabled={hasProblemsToSave()/*(evaluation.length === 0 && !notApply) && workCycle.length === 0 && targetCategory.length === 0 && targetCategoryApprove.length === 0 && targetClientProcedure.length === 0 && targetHomologousProcedure.length === 0 && (courseSupportFileDate === null || !loadDocument) || idSystemSpecialty === undefined || idTraining === '' || courseCode === '' || courseName === ''*/}
                                                    > Guardar</Button>
                                                    <Button
                                                        type="danger" 
                                                        ghost
                                                        variant='contained'
                                                        className={classes.button}
                                                        onClick={() => {
                                                            props.setTab('1')
                                                            dispatch(clearCourseMultimedia())
                                                            dispatch(attachmentClear())
                                                        }}
                                                    >Cancelar</Button>
                                                </div>
                                            </Grid>
                                        </Grid>

                                        <div>
                                            {
                                                isDocument ?
                                                    <Grid item xs={12}>
                                                        <TextEvents
                                                            text="Documentos"
                                                            color="cotemar"
                                                            size='subtitle'
                                                            weight="bold"
                                                        />
                                                        {documentStatusValidation() ?
                                                            <Alert
                                                                message="Disciplina Operacional requiere de al menos un documento para su guardado"
                                                                type="warning"

                                                            /> : ""
                                                        }

                                                        <AttachFileContainer
                                                            setAttachment={setAttachment}
                                                            localAttachment={localAttachment}
                                                            id={course.idCourse}
                                                            setMigrate={setMigrate}
                                                            courseSupportFileDate={courseSupportFileDate}
                                                            setCourseSupportFileDate={setCourseSupportFileDate}
                                                            loadDocument={loadDocument}
                                                            setLoadDocument={setLoadDocument}>
                                                            {
                                                                (params => {
                                                                    return <div />
                                                                })
                                                            }
                                                        </AttachFileContainer>
                                                    </Grid>
                                                    : isMultimedia ?
                                                        <Grid item xs={12} >
                                                            <TextEvents
                                                                text="Multimedia - Videos"
                                                                color="cotemar"
                                                                size='subtitle'
                                                                weight="bold"
                                                            />

                                                            <Alert
                                                                message="Disclaimer"
                                                                description="Se deberá solicitar la autorización oficial para el uso de videos propiedad de un tercero (aún sean partes del video completo). Cuando sea la reproducción parcial de un video de un tercero, se deberá indicar al final la fuente y propietario del video. No deberá utilizarse los videos propios de Cotemar para otros fines que no sean los indicados en Cotplay."
                                                                type="error"
                                                            />
                                                            <br />

                                                            <AzureMPContainer id={course.idCourse} setVideo={setVideo} disabled={onSiteTest || id === 0}>
                                                                {(() => {
                                                                    props.setLoader(video)
                                                                    return <div />
                                                                })}
                                                            </AzureMPContainer>
                                                            <Checkbox checked={notCotplayHub} onChange={(e) => { setNotCotplayHub(e.target.checked) }}>No mostrar CotPlay HUB
                                                            </Checkbox>

                                                        </Grid>
                                                        : isCategory ?
                                                            <Grid container direction="row" spacing={1}>
                                                                {
                                                                    validateAdminGeneralRol() ? (validateViewOptionsAdminGeneral("applyAll") ? applyAllCB() : <div></div>) : applyAllCB()
                                                                }
                                                                {
                                                                    validateAdminGeneralRol() ? (validateViewOptionsAdminGeneral("applyGCM") ? applyGCMCB() : <div></div>) : applyGCMCB()
                                                                }

                                                                {
                                                                    validateAdminGeneralRol() ? (validateViewOptionsAdminGeneral("notApplyColab") ? notApplyCB() : <div></div>) : notApplyCB()
                                                                }
                                                                <Grid xs={12} item>
                                                                    <TextEvents
                                                                        text='Selecciona puesto(s) de Colaborador(es)'
                                                                        color='darker'
                                                                        size='label'
                                                                        weight='medium'
                                                                    />
                                                                </Grid>
                                                                <Grid xs={12} item>
                                                                    <SubdirectionsContainer>
                                                                        {(params) => {
                                                                            return (
                                                                                <Select
                                                                                    disabled={true/*applyAll || notApplyColab*/}
                                                                                    placeholder={'Selecciona subdirección'}
                                                                                    value={subdirCategory !== undefined ? String(subdirCategory) : subdirCategory}
                                                                                    style={{ width: "740px" }}
                                                                                    onChange={(item) => {
                                                                                        findCategoryBySubdirection(item);
                                                                                    }}
                                                                                    showSearch
                                                                                    filterOption={(input, option) =>
                                                                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                                    }
                                                                                >
                                                                                    {
                                                                                        params.subdirs.map((item) =>
                                                                                            <Select.Option key={String(item.idSubdirection)} value={String(item.idSubdirection)}>
                                                                                                {item.subdirectionName}
                                                                                            </Select.Option>
                                                                                        )
                                                                                    }
                                                                                </Select>
                                                                            )
                                                                        }}
                                                                    </SubdirectionsContainer>
                                                                </Grid>

                                                                <Grid xs={12} item>
                                                                    <Transfer
                                                                        disabled={applyAll || notApplyColab || applyGCM}
                                                                        dataSource={dataSourceCategory.filter(x => String(x.idSubdirection) === String(subdirCategory))}
                                                                        titles={['Puestos disponibles', 'Puestos asignados']}
                                                                        listStyle={{
                                                                            width: 350,
                                                                            height: 300,
                                                                        }}
                                                                        showSearch
                                                                        filterOption={filterOptionCategory}
                                                                        targetKeys={targetCategory.filter(x => String(x.idSubdirection) === String(subdirCategory)).map(i => i.idCategory)}
                                                                        onChange={changeCategory}
                                                                        render={item => item.categoryName} />
                                                                </Grid>

                                                                {
                                                                    idTraining === 'TK0000000001' ?
                                                                        <Grid xs={12} item>
                                                                            <TextEvents
                                                                                text='Selecciona puesto(s) de Aprobador(es)'
                                                                                color='darker'
                                                                                size='label'
                                                                                weight='medium'
                                                                            />
                                                                            <SubdirectionsContainer>
                                                                                {(params) => {
                                                                                    return (
                                                                                        <Select
                                                                                            placeholder={'Selecciona subdirección'}
                                                                                            value={subdirCategoryApprove !== undefined ? String(subdirCategoryApprove) : subdirCategoryApprove}
                                                                                            style={{ width: "740px" }}
                                                                                            onChange={(item) => {
                                                                                                findCategoryBySubdirectionApprove(item);
                                                                                            }}
                                                                                            showSearch
                                                                                            filterOption={(input, option) =>
                                                                                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                                            }
                                                                                        >
                                                                                            {
                                                                                                params.subdirs.map((item) =>
                                                                                                    <Select.Option key={String(item.idSubdirection)} value={String(item.idSubdirection)}>
                                                                                                        {item.subdirectionName}
                                                                                                    </Select.Option>
                                                                                                )
                                                                                            }
                                                                                        </Select>
                                                                                    )
                                                                                }}
                                                                            </SubdirectionsContainer>
                                                                        </Grid> : <div></div>
                                                                }

                                                                {
                                                                    idTraining === 'TK0000000001' ?
                                                                        <Grid xs={12} item >
                                                                            <Transfer
                                                                                disabled={applyAll || notApplyColab || applyGCM}
                                                                                dataSource={dataSourceCategoryApprove.filter(x => String(x.idSubdirection) === String(subdirCategoryApprove))}
                                                                                titles={['Puestos disponibles', 'Puestos asignados']}
                                                                                listStyle={{
                                                                                    width: 350,
                                                                                    height: 300,
                                                                                }}
                                                                                showSearch
                                                                                filterOption={filterOptionCategory}
                                                                                targetKeys={targetCategoryApprove.filter(x => String(x.idSubdirection) === String(subdirCategoryApprove)).map(i => i.idCategory)}
                                                                                onChange={changeCategoryApprove}
                                                                                render={item => item.categoryName} />
                                                                        </Grid> : <div></div>
                                                                }
                                                            </Grid>


                                                            : isWorkCycle ?

                                                                <Grid xs={12} item >
                                                                    <TextEvents
                                                                        text='Selecciona el Ciclo de Trabajo'
                                                                        color='darker'
                                                                        size='label'
                                                                        weight='medium'
                                                                    />
                                                                    <CourseWorkCycleAvailableContainer id={id}>
                                                                        {(params) => {
                                                                            return (
                                                                                <Select
                                                                                    showSearch
                                                                                    value={workCycle.length > 0 ? String(workCycle[0].idTest) : undefined}
                                                                                    //defaultValue={{ key: workCycle.length > 0 ? String(workCycle[0].idTest) : '' }}
                                                                                    style={{ width: "100%" }}
                                                                                    placeholder='Selecciona el ciclo de trabajo'
                                                                                    filterOption={filterOptionWorkCycle}
                                                                                    onChange={(v) => {
                                                                                        findWorkCycle(params, v);
                                                                                    }}
                                                                                >
                                                                                    {
                                                                                        params.courseWorkCycleAvailable.map((item) => {
                                                                                            return (
                                                                                                <Select.Option key={String(item.idTest)} value={String(item.idTest)}>
                                                                                                    {item.testFolio + ' - ' + item.testTitle}
                                                                                                </Select.Option>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                </Select>
                                                                            )
                                                                        }}
                                                                    </CourseWorkCycleAvailableContainer>

                                                                </Grid>

                                                                : isTest ?
                                                                    <Grid xs={12} item >
                                                                        <TextEvents
                                                                            text='Selecciona la Evaluación'
                                                                            color='darker'
                                                                            size='label'
                                                                            weight='medium'
                                                                        />
                                                                        <CourseTestAvailableContainer id={id} idTraining={idTraining}>
                                                                            {(params) => {
                                                                                return (
                                                                                    <Select
                                                                                        showSearch
                                                                                        disabled={notApply}
                                                                                        value={evaluation.length > 0 ? String(evaluation[0].idTest) : undefined}
                                                                                        //defaultValue={{ key: evaluation.length > 0 ? String(evaluation[0].idTest) : '' }}
                                                                                        style={{ width: "100%" }}
                                                                                        placeholder='Selecciona la Evaluación'
                                                                                        filterOption={filterOptionEV}
                                                                                        onChange={(v) => {
                                                                                            findEvaluation(params, v);
                                                                                        }}
                                                                                    >
                                                                                        {
                                                                                            params.courseTestAvailable.map((item) => {
                                                                                                return (
                                                                                                    <Select.Option key={String(item.idTest)} value={String(item.idTest)}>
                                                                                                        {item.testFolio + ' - ' + item.testTitle}
                                                                                                    </Select.Option>
                                                                                                )
                                                                                            })
                                                                                        }
                                                                                    </Select>
                                                                                )
                                                                            }
                                                                            }
                                                                        </CourseTestAvailableContainer>
                                                                        {
                                                                            validateAdminGeneralRol() ? (validateViewOptionsAdminGeneral("notApply") ? notApplyEvaCB() : <div></div>) : (idTraining !== 'TK0000000001' ? notApplyEvaCB() : <div></div>)
                                                                        }
                                                                    </Grid>

                                                                    : isClientProcedure && subdir[0].idSubdirection === 3 && idTraining === 'TK0000000001' ?
                                                                        <Grid xs={12} item >
                                                                            <Tabs defaultActiveKey="1">
                                                                                <TabPane tab="Clasificación del Cliente" key="1">
                                                                                    <TextEvents
                                                                                        text='Selecciona Clasificación del Cliente'
                                                                                        color='darker'
                                                                                        size='label'
                                                                                        weight='medium'
                                                                                    />
                                                                                    <CourseClientProcedureAvailableContainer id={course.idCourse}>
                                                                                        {(params) => {
                                                                                            setsourceClientProcedure(params.courseClientProcedureAvailable);
                                                                                            return (
                                                                                                <Transfer
                                                                                                    dataSource={sourceClientProcedure}
                                                                                                    titles={['Disponibles', 'Asignadas']}
                                                                                                    listStyle={{
                                                                                                        width: 300,
                                                                                                        height: 300,
                                                                                                    }}
                                                                                                    showSearch
                                                                                                    filterOption={filterOptionClientProcedure}
                                                                                                    targetKeys={targetClientProcedure}
                                                                                                    onChange={(e) => {
                                                                                                        let sourceClientsChange = [...sourceClientProcedure];
                                                                                                        let filtered = [];
                                                                                                        const passed = [];
                                                                                                        e.forEach(i => {
                                                                                                            filtered = sourceClientsChange.filter(f => f.key === i)
                                                                                                            passed.push(filtered[0])
                                                                                                        });
                                                                                                        sourceClientsChange.forEach(i => {
                                                                                                            if (passed.length === 0) i.disabled = false;
                                                                                                            passed.forEach(p => {
                                                                                                                i.disabled = false;
                                                                                                                if (i.idClient === p.idClient) i.disabled = true;
                                                                                                                if (i.key === p.key) i.disabled = false;
                                                                                                            })
                                                                                                        });
                                                                                                        setsourceClientProcedure(sourceClientsChange);
                                                                                                        setsourceClientProcedure(sourceClientsChange)
                                                                                                        return settargetClientProcedure(e);
                                                                                                    }}
                                                                                                    render={item => item.procedureName} />
                                                                                            )
                                                                                        }}
                                                                                    </CourseClientProcedureAvailableContainer>

                                                                                </TabPane>
                                                                                <TabPane tab="Procedimientos Homólogos" key="2">
                                                                                    <TextEvents
                                                                                        text='Selecciona Procedimientos Homólogos'
                                                                                        color='darker'
                                                                                        size='label'
                                                                                        weight='medium'
                                                                                    />
                                                                                    <CourseHomologousProcedureAvailableContainer id={course.idCourse}>
                                                                                        {(params) => {
                                                                                            setsourceHomologousProcedure(params.courseHomologousProcedureAvailable);
                                                                                            return (
                                                                                                <Transfer
                                                                                                    dataSource={sourceHomologousProcedure}
                                                                                                    titles={['Disponibles', 'Asignadas']}
                                                                                                    listStyle={{
                                                                                                        width: 300,
                                                                                                        height: 300,
                                                                                                    }}
                                                                                                    showSearch
                                                                                                    filterOption={filterOptionHomologousProcedure}
                                                                                                    targetKeys={targetHomologousProcedure}
                                                                                                    onChange={e => settargetHomologousProcedure(e)}
                                                                                                    render={item => item.procedureName} />
                                                                                            )
                                                                                        }}
                                                                                    </CourseHomologousProcedureAvailableContainer>
                                                                                </TabPane>
                                                                            </Tabs>
                                                                        </Grid>
                                                                        : ''


                                            }
                                        </div>
                                    </CardContent>
                                </Card>

                            </Grid>
                            :
                            <Grid xs={8} item>
                                <Card className={classes.card}>
                                    <CardContent>

                                        <Grid container direction="row">
                                            <Grid item xs={12}>

                                                <TextInput
                                                    disabled
                                                    value={courseFolio}
                                                    setValue={setCourseFolio}
                                                    text='Folio'
                                                    color='darker'
                                                    size='label'
                                                    weight='medium'
                                                    mode='input'
                                                    onChange={e => setCourseFolio(e.target.value)}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container direction="row">
                                            <Grid xs={12} item className={classes.gridSeparatorRight}>

                                                <Grid item xs={12}>
                                                    <TextEvents
                                                        text='Subdirección Origen'
                                                        color='darker'
                                                        size='label'
                                                        weight='medium'
                                                    />
                                                    <SubdirectionsContainer>
                                                        {(params) => {
                                                            return (
                                                                <Select
                                                                    disabled={true}
                                                                    placeholder={'Selecciona subdirección'}
                                                                    value={subdir.length > 0 ? String(subdir[0].idSubdirection) : null}
                                                                    style={{ width: "100%" }}
                                                                    onChange={(item) => {
                                                                        findSubdir(params, item);
                                                                    }}
                                                                >
                                                                    {
                                                                        params.subdirs.map((item) =>
                                                                            <Select.Option key={String(item.idSubdirection)} value={String(item.idSubdirection)}>
                                                                                {item.subdirectionName}
                                                                            </Select.Option>
                                                                        )
                                                                    }
                                                                </Select>
                                                            )
                                                        }}
                                                    </SubdirectionsContainer>
                                                </Grid>
                                                <Grid container spacing={1} direction="row">
                                                    <Grid item xs={6}>
                                                        <TextEvents
                                                            text='Tipo de Capacitación'
                                                            color='darker'
                                                            size='label'
                                                            weight='medium'
                                                        />
                                                        <Select
                                                            placeholder={'Selecciona Tipo de Capacitación'}
                                                            loading={isLoadTrainingSelect}
                                                            value={idTraining}
                                                            style={{ width: "100%" }}
                                                            onChange={(item) => {
                                                                if (item !== idTraining) {
                                                                    setEvaluation([]);
                                                                    dispatch(fetchTestAvailableCourseById(id, item));
                                                                }
                                                                setIdTraining(item);
                                                                setIdSystemSpecialty(undefined);
                                                                if (item === 'TK0000000001') setNotApply(false);
                                                            }}
                                                            showSearch
                                                            filterOption={(input, option) =>
                                                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                            }
                                                        >
                                                            {optionTraining}
                                                        </Select>
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <TextEvents
                                                            text='Especialidad/Sistema'
                                                            color='darker'
                                                            size='label'
                                                            weight='medium'
                                                        />
                                                        <Select
                                                            placeholder={'Selecciona' + (idTraining === undefined ? ' un Tipo de Capacitación' : (idTraining === 'TK0000000002' ? ' Sistema' : ' Especialidad'))}
                                                            loading={isLoadSystemSpecialty}
                                                            value={idSystemSpecialty}
                                                            style={{ width: "100%" }}
                                                            showSearch
                                                            filterOption={(input, option) =>
                                                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                            }
                                                            onChange={(item) => {
                                                                setIdSystemSpecialty(item);
                                                            }}
                                                        >
                                                            {
                                                                idTraining === undefined ? [] : (
                                                                    idTraining === 'TK0000000002' ? optionSystem : optionSpecialty
                                                                )
                                                            }
                                                        </Select>
                                                    </Grid>
                                                </Grid>

                                                <TextInput
                                                    value={courseCode}
                                                    setValue={setCourseCode}
                                                    text='Código'
                                                    color='darker'
                                                    size='label'
                                                    weight='medium'
                                                    mode='input'
                                                    placeholder='Código'
                                                    onChange={e => setCourseCode(e.target.value)}
                                                />

                                                <TextInput
                                                    value={courseName}
                                                    setValue={setCourseName}
                                                    text='Nombre'
                                                    color='darker'
                                                    size='label'
                                                    weight='medium'
                                                    mode='input'
                                                    placeholder='Nombre'
                                                    onChange={e => setCourseName(e.target.value)}
                                                />
                                            </Grid>

                                        </Grid>

                                        <div>
                                            <TextEvents
                                                text='Descripción'
                                                color='darker'
                                                size='label'
                                                weight='medium'
                                            />
                                            <TextArea
                                                value={description}
                                                onChange={e => setDesc(e.target.value)}
                                                autoSize={{ minRows: 5, maxRows: 6 }}
                                                placeholder='Descripción'
                                            />
                                        </div>

                                        <Grid container direction="row">
                                            <Grid xs={12} item className={classes.gridSeparatorRight}>
                                            </Grid>
                                            <Grid xs={6} item className={classes.gridSeparatorRight}>
                                                <TextInput
                                                    disabled
                                                    text='Estatus'
                                                    color='darker'
                                                    size='label'
                                                    weight='medium'
                                                    mode="multiple"
                                                    placeholder="Edición"
                                                >
                                                </TextInput>
                                            </Grid>

                                            <Grid xs={6} item className={classes.gridSeparatorLeft}>
                                                <TextInput
                                                    disabled
                                                    value={version}
                                                    setValue={setVersion}
                                                    text='Versión'
                                                    color='darker'
                                                    size='label'
                                                    weight='medium'
                                                    mode='input'
                                                    placeholder='Versión'
                                                    onChange={e => setVersion(e.target.value)}
                                                >
                                                </TextInput>
                                            </Grid>
                                        </Grid>
                                        <div className={classes.buttonsContainer}>
                                            <Button
                                                variant='contained'
                                                type='primary'
                                                onClick={showConfirm}
                                                disabled={subdir.length === 0 || idSystemSpecialty === undefined || idTraining === '' || courseCode === '' || courseName === '' || isSaved}
                                            > Guardar</Button>
                                            <Button
                                                type="danger" 
                                                ghost
                                                className={classes.button}
                                                onClick={() => props.setTab('1')}
                                            >Cancelar</Button>
                                        </div>
                                    </CardContent>
                                </Card>

                            </Grid>
                    }

                </Grid>
            </Grid>
        </div>
    );
}